import { ChangeDetectorRef, Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import * as $ from 'jquery';
import { saveAs } from 'file-saver';
import { NicaFormComponent } from '../nica-form/nica-form.component';
import { HttpClient } from '@angular/common/http';
import { NicaMaster } from '../nica-master-component/nica-master.component';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';


@Component({
  selector: 'app-contatti',
  templateUrl: './contatti.component.html',
  styleUrls: ['./contatti.component.css']
})
export class ContattiComponent extends NicaMaster implements OnInit {

  @ViewChild('dataGridContatti', { static: false }) dataGridContatti: NicaAnagraficaComponent;
  @ViewChild('contattiForm', { static: false }) contattiForm: NicaFormComponent;
  //@ViewChild('anteprimaPDF', { static: false, read: ViewContainerRef }) anteprimaPDF: ViewContainerRef;


  @Input() itemData: any
  @Input() queryString: any
  @Input() dataJson: any
  @Output() emittedData: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno

  myFilterStr: any;
  idTabRif: number; //id del dettaglio (anagrafica precedente)
  nomeTabRif: any;  //nome tabella (anagrafica precedente)
  dati: any; //dati del dettaglio (anagrafica precedente)
  queryStringForm: string = '';
  formContattiVisibile: boolean = false;
  pWidth: number = 855
  pHeight: number = 500
  formHeight: number = 434;
  gridHeight: number = 500;
  dataRow: { nomeTabella: any; idTabella: number; };
  isEditForm:boolean = false
  titleDynamic: string;




  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,

    private changeDetector?: ChangeDetectorRef,
    private http?: HttpClient,

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,


    );


  }

  ngOnInit(): void {

    this.activatedroute.queryParams.subscribe((params) => {
      
      this.currentTabId = params.currentTabId,
      this.currentTabName = params.currentTabName
      
      this.setGlobalVariableFromParams(params);

      
    })
    

    if (this.dataJson) {
      
     
      this.idTabRif = this.dataJson['idTabella'];
      this.nomeTabRif = this.dataJson['nomeTabella'];
      if (typeof this.dataJson['infoButton'] != 'undefined') {
        this.pWidth = this.dataJson['infoButton']['wPopUp'];
        this.pHeight = this.dataJson['infoButton']['hPopUp'];
        this.formHeight = this.pHeight - 67;
       
      }
      //this.dati = this.dataJson['dati'];
      this.myFilterStr = '?NomeTabella=' + this.nomeTabRif + '&IdTabella=' + this.idTabRif;
      
      this.dataRow = {

        nomeTabella:this.nomeTabRif,
        idTabella:this.idTabRif

      }

    }

    this.helpDoc = 'Contatti.html'

  }

  emettiChiusuraCaption(evt){

    if(evt == 'closePopUpOverlay'){


      this.userComponentService.destroyCurrentOpenPopUp('ContattiComponent')
    }

  }


  onAllEventContatto(evt: any) {

    let t = this;
    
    
    if (evt.name == "onInitNewRow") {
      
      
      evt.cancel = true;
      
      this.formContattiVisibile = true;
      this.isEditForm = false
      this.changeDetector.detectChanges();
      this.myFilterStr = '?NomeTabella=' + this.nomeTabRif + '&IdTabella=' + this.idTabRif;
      
      this.dataRow = {
        nomeTabella : this.nomeTabRif,
        idTabella:this.idTabRif
      } 

      this.titleDynamic = 'Inserisci contatto'

      this.openEditor()
    }
    
    
    if (evt.name == "onEditorPrepared") {
      
      //this.myFilterStr =  '';
      this.isEditForm = true
      evt.cancel = true;
      
      this.queryStringForm = '/' + evt.data.id;
      
      //this.formContattiVisibile = true;
      this.titleDynamic = 'Modifica contatto'  
      this.openEditor()
    }


  }



  //Da richieste ora questo metodo è in disuso
  gestisciEventoPulsante(evt: any) {

    if (evt.name == 'return') {
      this.formContattiVisibile = false;
      this.queryStringForm = ''
      this.isEditForm = !this.isEditForm;
    }

    switch (evt.name) {

      case 'submittedInsertOk': {

        this.dataGridContatti.refresh();
        //this.formContattiVisibile = false;
        
        this.isEditForm = !this.isEditForm;
      }
        break;
      case 'submittedEditOk': {

        this.dataGridContatti.refresh();
        //this.formContattiVisibile = false;
        this.isEditForm = !this.isEditForm;
      }
        break;

    }


  }



  onChiudiPopupForm(evt) {
    this.myFilterStr = '?NomeTabella=' + this.nomeTabRif + '&IdTabella=' + this.idTabRif;
    this.changeDetector.detectChanges();
    this.formContattiVisibile = false;
    this.isEditForm = !this.isEditForm

    this.dataRow = null;
    this.queryStringForm = '';
    

  }

  openEditor(){

    let dataToSend = {
      dataJson:this.dataRow,
      service:'Contatto',
      api:'Contatto',
      disableEditForm:false,
      isEdit:this.isEditForm,
      heightForm:this.formHeight,
      nCol:1,
      toolbarBottom:true,
      queryString:this.queryStringForm
    }
    
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, 'NewNicaFormComponent', null, '800', null,dataToSend,false, true, this.titleDynamic);
    this.userComponentService.outputComponent.subscribe(res => {
      
      if (res.name == 'return' && res.guid == guid) {
       
        this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)

        return;
      }

      if(res.name == 'submittedInsertOk' && res.guid == guid){
        
        this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
        this.isEditForm = !this.isEditForm;

        this.dataGridContatti.refresh();
      }
      
      if(res.name == 'submittedEditOk' && res.guid == guid){
        
        this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
        this.isEditForm = !this.isEditForm;
        this.dataGridContatti.refresh();
      }

    })

  }
}


